var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-tour-360-viewer"},[_c('transition',{attrs:{"name":"the-tour-360-viewer__transition--slide-left-short"}},[_c('iframe',{key:_vm.url,staticClass:"the-tour-360-viewer__iframe",attrs:{"src":_vm.url},on:{"load":_vm.removeCanvasOutlineOfLayamaTour360}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }